import dynamic from 'next/dynamic';

const EmbeddedCheckoutSingle = dynamic(() =>
  import(/* webpackChunkName: "blazePluginEcommerceStripeEmbeddedCheckoutSingle" */ './EmbeddedCheckoutSingle')
);

const EmbeddedCheckoutForm = dynamic(() =>
  import(/* webpackChunkName: "blazePluginEcommerceStripeEmbeddedCheckoutForm" */ './EmbeddedCheckoutForm')
);

const EmbeddedPayment = dynamic(() =>
  import(/* webpackChunkName: "blazePluginEcommerceStripeEmbeddedCheckoutForm" */ './EmbeddedPayment')
);

const pageBuilderComponent = {
  'blaze-ecommerce-stripe-embedded-checkout-single': EmbeddedCheckoutSingle,
  'blaze-ecommerce-stripe-embedded-checkout-form': EmbeddedCheckoutForm,
  'blaze-ecommerce-stripe-embedded-payment': EmbeddedPayment
};

export default pageBuilderComponent;
